import { Fragment, StrictMode } from 'react'
import type { FC } from 'react'
import { Conditional } from '@opallabs/kuiper'
import { capitalCase } from '@opallabs/lambda'
import { TabLabelPosition } from '../../Tabs'
import type { TabContentsProps } from '../types'
import * as styles from './styles'

export type { TabContentsProps }

export const TabContents: FC<React.PropsWithChildren<TabContentsProps>> = ({
  allowTranslation = true,
  children,
  displayLabel = true,
  icon,
  label,
  labelPosition = TabLabelPosition.End,
}) => {
  const renderedLabel = displayLabel ? (
    <span css={styles.label} translate={allowTranslation ? undefined : 'no'}>
      {capitalCase(label)}
    </span>
  ) : undefined

  return (
    <StrictMode>
      <Fragment>
        <Conditional condition={labelPosition === TabLabelPosition.Start}>
          {renderedLabel}
        </Conditional>

        {children}
        {icon}

        <Conditional condition={labelPosition === TabLabelPosition.End}>
          {renderedLabel}
        </Conditional>
      </Fragment>
    </StrictMode>
  )
}
TabContents.displayName = 'Lapidary Unstable: TabContents ← Tab'
